import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-domain-viewer',
  templateUrl: './domain-viewer.component.html',
  styleUrls: ['./domain-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DomainViewerComponent implements OnInit, OnDestroy {
  public domain: string;
  public loading = false;

  constructor(private userService: UserService) {
  }

  ngOnInit(): void {
    this.domain = localStorage['domain'];
    this.userService.userSubject.subscribe((user) => {
      user ? this.domain = localStorage['domain'] : this.domain = null;
    });
  }

  ngOnDestroy(): void {
    this.userService.userSubject.unsubscribe();
  }
}
